import { Service } from '../Service';
export default class DownloadService extends Service {
    constructor(axios) {
        super(axios);
    }
}
export { DownloadService };
